<template>
	<div>
		<div class="top_box">
			<h2>{{langtrans().jyzzaj[languageIndex]}}</h2>
			<div class="time_box">
				<div class="block st_box">
					{{langtrans().qssjj[languageIndex]}}
					<el-date-picker @change="sttime()" v-model="st_time" align="right" type="date" :placeholder="langtrans().qssjj[languageIndex]" :picker-options="pickerOptions1">
					</el-date-picker>
				</div>
				<div class="block en_box">
					{{langtrans().jjss[languageIndex]}}
					<el-date-picker @change="entime()" v-model="en_time" align="right" type="date" :placeholder="langtrans().jjssjj[languageIndex]" :picker-options="pickerOptions1">
					</el-date-picker>
				</div>
				<div class="block en_box">
					{{langtrans().ajbh[languageIndex]}}
					<el-input v-model="caseNo" :placeholder="langtrans().ajbh[languageIndex]" style="width: 213px;"></el-input>
				</div>
				<div class="block">
					<el-button type="primary" @click="filt()">{{langtrans().czx[languageIndex]}}</el-button>
				</div>
			</div>
		</div>
		<div class="form_box">
			<el-table :empty-text="langtrans().zwmsss[languageIndex]" :data="tableData" border>
				<el-table-column prop="number" :label="langtrans().xhh[languageIndex]" min-width="50">
				</el-table-column>
				<el-table-column prop="caseNo" :label="langtrans().ajbhh[languageIndex]" min-width="70">
				</el-table-column>
				<el-table-column prop="address" :label="langtrans().ffsddd[languageIndex]" min-width="70">
				</el-table-column>
				<el-table-column prop="username" :label="langtrans().yhxm[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="phone" :label="langtrans().yhsjhh[languageIndex]" min-width="70">
				</el-table-column>
				<el-table-column prop="papers" :label="langtrans().zjxsxx[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="sex" :label="langtrans().xbb[languageIndex]" min-width="50">
				</el-table-column>
				<el-table-column prop="time" :label="langtrans().cxsjj[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="par" :label="langtrans().yhbxxq[languageIndex]" min-width="90">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">{{langtrans().bxxqq[languageIndex]}}</el-button>
						<el-button type="text" size="small" v-show="!scope.row.isshow">{{langtrans().wm[languageIndex]}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="plan" :label="langtrans().ddqjdd[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="node" :label="langtrans().ddqjjd[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="get_time" :label="langtrans().hfsjj[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="op" :label="langtrans().cczzz[languageIndex]" min-width="100">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="tores(scope.row)">{{langtrans().ksjy[languageIndex]}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
        <el-pagination
      style="margin-top: 15px;float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[20]"
      :page-size="20"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
	</div>
</template>

<script>
	import langtrans from "./js/rescue.vue.trans.js";
	import formVue from "./form.vue";
	import { Message } from "element-ui";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from 'promise-polyfill';
	import { getAwaitData } from '@/views/axios/api.js';
	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		components: {
			formVue
		},
		data() {
			return {
         start:0,
        count:20,
        total:0,
        currentPage4: 1,
				tableData: [],
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				st_time: "",
				en_time: "",
				caseNo: "",
				pickerOptions1: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				caseId: [],
				typeId: this.$route.query.typeId
			};
		},
		methods: {
      handleSizeChange(val) {
         this.count = val
             this.getData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.start = (val-1) * this.count;
        // this.start = val * 10
            this.getData()
        console.log(`当前页: ${val}`);
      },
			setTxt(str,status){
				return constants.setTxt(str,status,true)
			},				
			langtrans() {
				return langtrans
			},
			filt() {
				this.getData(this.st_time, this.en_time + 86400000);
			},
			sttime() {
				this.st_time = this.st_time * 1;
				if(this.en_time + 86400000 < this.st_time && this.en_time != "") {
					Message.error(this.langtrans().jjssjj[this.languageIndex]);
				}
				// this.getData(this.st_time, 0);
				// console.log(this.st_time);
			},
			entime() {
				this.en_time = this.en_time * 1;
				if(this.en_time + 86400000 < this.st_time && this.en_time != "") {
					Message.error(this.langtrans().jjssjj[this.languageIndex]);
				}
				// this.getData(0, this.en_time + 86400000);
			},
			getData(st, et) {
				this.tableData = [];
				let n = 0;
				let sex = "";
				let isshow = false;
				var data={
					token:JSON.parse(window.localStorage.getItem("data")).data,
					typeId:this.typeId,
					status:180,
					startTs:this.st_time,
					endTs:this.en_time,
         start:this.start,
         count:this.count,
         caseNo:this.caseNo
				}
				getAwaitData(data)
					.then(data => {
						var data=data.data
             this.total = data.total
						if(data.obj) {
							data.obj.map(v => {
								this.caseId.push(v.obj.id);
								n = n + 1;
								if(this.languageIndex == 0){
									if(v.victimList[0].obj.gender == 1) {//汉语
										sex = "男";
									} else {
										sex = "女";
									}										
								}else{
									if(v.victimList[0].obj.gender == 1) {//汉语
										sex = "Male";
									} else {
										sex = "Female";
									}										
								}

								if(
									v.victimList[0].obj.insurancePolicyNo &&
									v.victimList[0].obj.insurancePolicyNo != ""
								) {
									isshow = true;
								} else {
									isshow = false;
								}
								var address = "";
									if(v.generalLocation){
										if(!constants.setTxt(v.generalLocation.addr,'zh')){
											address=v.generalLocation.addr
										}else{
											address=this.languageIndex== 0 ? constants.setTxt(v.generalLocation.addr,'zh') : constants.setTxt(v.generalLocation.addr,'en')
										}
									}		
								var pt = constants.pt2txt(v.obj.caseState);
								if(this.languageIndex == 1){									
									pt.phase = pt.phaseEn
									pt.node = pt.nodeEn
								}
								this.tableData.push({
                  caseId:v.obj.id,
									number: n, //序号
									caseNo: v.obj.caseNo, //案件编号
									address, //地址
									username: v.victimList[0].obj.victimName, //姓名
									phone: v.obj.reporterContact, //联系方式
									papers: constants.strHidden(v.victimList[0].obj.idNo) || "无", //身份证号
									sex: sex, //性别
									time: constants.time(v.obj.incidentTs), //出险时间
									isshow: isshow, //保单
									insuranceUrl: v.insuranceUrl,
									plan: pt.phase, //进度
									node: pt.node, //节点
									get_time: constants.time(v.rInstiFeedbackTs),
									op: this.langtrans().czkkbb[this.languageIndex]
								});
								//   that.obj.push(v.obj);
								//   that.victimList.push(v.victimList[0]);

							});
						}
					});
			},
			toUrl(url) {
				//window.open(url);
			},
			tores(data) {
				console.log(data);
				this.$router.push({
					name: "resstep",
					params: {
						token: this.$route.params.token ||
							JSON.parse(window.localStorage.getItem("data")).data
					},
					query: {
						typeId: this.typeId,
						caseid: data.caseId
					}
				});
			},

		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
			window.localStorage.setItem(
				"case",
				JSON.stringify({
					case: "Rescue"
				})
			);
			this.getData();
		},
		watch:{
			// caseNo(nv, ov) {
			// 	console.log('案件编号变化:', nv);
			// 	this.getData();
			// },
			languageIndex(){
				this.getData()
			}
		}
	};
</script>

<style scoped>
	@import url("../../css/table.css");
</style>


// WEBPACK FOOTER //
// src/components/fac/rescue.vue